import { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../components/Loading";
import "../assets/css/activity.css";
import { FaReply, FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";

const Activity = () => {
  const { url, user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const getActivityToken = async () => {
    try {
      const res = await axios.get(`${url}/activity_token`);
      return res.data.token[0].token;
    } catch (error) {
      console.log(error);
    }
  };

  const getActivity = async () => {
    setLoading(true);
    try {
      const token = await getActivityToken();
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/creator/v2.1/data/singledebt100/debt-management/report/Time_Line_New_Report?Customer_Email=${user.Email}`,
        {
          headers: {
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setData(res.data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getActivity();
  }, []);

  const [showReply, setShowReply] = useState(false);
  const [replyID, setReplyID] = useState("");
  const [replyInput, setReplyInput] = useState("");
  useEffect(() => {
    if (replyID !== "") {
      setShowReply(true);
    } else {
      setShowReply(false);
    }
  }, [replyID]);
  const sendReply = async () => {
    const data = [
      {
        Customer_comments: replyInput,
      },
    ];
    try {
      const token = await getActivityToken();
      const res = await axios.put(
        `${url}/proxy?url=https://www.zohoapis.in/creator/v2.1/data/singledebt100/debt-management/report/Time_Line_New_Report/${replyID}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setReplyID("");
        setReplyInput("");
        getActivity();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="container p-2 py-4">
        <h2 className="text-center mb-3">Activity</h2>
        {loading ? (
          <Loading />
        ) : (
          <>
            {data.length !== 0 ? (
              <>
                {data.map((item, index) => {
                  return (
                    <div
                      className={`border bg-white rounded p-2 ${
                        index === data.length - 1 ? "" : "mb-2"
                      }`}
                      key={index}
                    >
                      <p>
                        <span className="fw-bold">Agent Remark</span>:{" "}
                        {item.Status}
                      </p>
                      {item.Customer_comments && (
                        <p className="my-2">
                          <span className="fw-bold">Customer comment</span>:
                          {item.Customer_comments}
                        </p>
                      )}
                      <p>
                        <span className="fw-bold">Date</span>:{item.Date_field}
                      </p>
                      <div className="reply-flex">
                        {showReply && replyID === item.ID ? (
                          <>
                            <div>
                              <input
                                type="text"
                                className="form-input"
                                value={replyInput}
                                onChange={(e) => setReplyInput(e.target.value)}
                              />
                            </div>
                            <div>
                              <button
                                className="button d-flex align-items-center justify-content-center w-100"
                                onClick={() => sendReply(item.ID)}
                              >
                                Submit
                                <FaReply className="ms-2" />
                              </button>
                            </div>
                            <div>
                              <button
                                className="button w-100 text-center"
                                onClick={() => setReplyID("")}
                              >
                                Cancel <FaTimes />
                              </button>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {!showReply && !item.Customer_comments ? (
                          <div>
                            <button
                              className="button reply-button"
                              onClick={() => setReplyID(item.ID)}
                            >
                              <FaReply className="me-2" />
                              Reply
                            </button>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <p className="text-center my-4">No data found</p>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Activity;
